import LogRocket from 'logrocket';
import { LOG_ROCKET_APP_ID, LOG_ROCKET_ENABLED } from '~/config';

if( LOG_ROCKET_ENABLED ) {
	LogRocket.init(LOG_ROCKET_APP_ID);
}
